import * as React from 'react';
import { Link } from 'react-router-dom';

const BannerCustomLink = ({
  href,
  children,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const shouldUseAnchorTag = !href || href.includes('https://') || href.includes('http://');

  if (shouldUseAnchorTag) {
    return (
      <a href={href} target="_blank" rel="noreferrer" {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link {...props} to={href}>
      {children}
    </Link>
  );
};

export default BannerCustomLink;
